const comments = [
  {
    name: '追剧小达人',
    time: '2小时前',
    content: '丫丫影院真的良心！狂飙全集一次性看完，高清不卡顿，比那些要充会员的网站好太多了。已经推荐给身边所有追剧的朋友了！',
    likes: '326',
  },
  {
    name: '电影爱好者阿明',
    time: '5小时前',
    content: '找了很久的庆余年第二季，终于在丫丫影院看到了。更新速度超快，画质也很清晰，投屏到电视上看简直不要太爽。',
    likes: '218',
  },
  {
    name: '深夜剧迷',
    time: '8小时前',
    content: '不用注册就能看全集这点太赞了。墨雨云间每天更新第一时间就能看，而且片源很全，韩剧美剧国产剧都有覆盖。',
    likes: '189',
  },
  {
    name: '周末宅家党',
    time: '12小时前',
    content: '周末一口气刷了十几集与凤行，全程无广告无弹窗，观影体验堪比付费平台。界面也很简洁，手机上看一点都不费流量。',
    likes: '145',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">观众热评</h2>
          <p className="text-sm text-foreground-500">来自丫丫影院用户的真实观影感受</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((c, idx) => (
            <div key={idx} className="rounded-xl bg-background-50 border border-background-200 p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-600">{c.name[0]}</span>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-400">{c.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{c.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{c.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}